import formInfo from './form-info.vue'

export default formInfo
